import FormioExport from './formio-export';
if (typeof global === 'object') {
  global.FormioExport = FormioExport;
}
export default FormioExport;

